import cl from 'clsx';
import Label from './Label';
import React from 'react';
const ErrorMessage = (props) => (React.createElement(Label, Object.assign({}, props, { as: 'div', className: cl('cds-error-message', props.className) })));
ErrorMessage.displayName = 'ErrorMessage';
export default ErrorMessage;
